'use client';

import { QueryProvider } from '@/services/query/QueryProvider';
import { RootProviderProps } from './RootProvider.types';
import { AuthProvider } from './store';
import ChakraThemeProvider from './ThemeProvider/ThemeProvider';

function RootProvider({ children }: RootProviderProps) {
   return (
      <QueryProvider>
         <ChakraThemeProvider>
            <AuthProvider>{children}</AuthProvider>
         </ChakraThemeProvider>
      </QueryProvider>
   );
}

export default RootProvider;
